const LOCAL_STORAGE_ADRESSES_KEY = 'shipments.user.local_email_addresses';

export class EmailAdressesHelper {
  // These methods manage email addresses on local storage
  private _localEmailAddresses: string[];
  public get localEmailAddresses(): string[] {
    if (this._localEmailAddresses == null) {
      const val = localStorage.getItem(LOCAL_STORAGE_ADRESSES_KEY);
      if (!val) {
        this._localEmailAddresses = [];
      } else this._localEmailAddresses = val.split(',');
    }

    return this._localEmailAddresses;
  }
  public set localEmailAddresses(value: string[]) {
    localStorage.setItem(LOCAL_STORAGE_ADRESSES_KEY, value.toString());
    this._localEmailAddresses = value;
  }
}
